import { render, staticRenderFns } from "./TraderTypeSelect.vue?vue&type=template&id=3b50d79b&"
import script from "./TraderTypeSelect.vue?vue&type=script&lang=js&"
export * from "./TraderTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports